import { z } from 'zod';
import { opgavekompleksetV1DataSchema } from './_component-data.v1.js';
import { opgavekompleksetV2DataSchema } from './_component-data.v2.js';

/**
 * Full specification of an OpgaveKomplekset component, including all tasks
 * data, transformed into a desired format.
 */

const opgavekompleksetDataSchema = z.preprocess(data => {
  if (typeof data === "object" && data != null) {
    // @ts-expect-error Ensure that unversioned data is reset to version "1"
    // (NB: all versions hereafter must be version tagged)
    data.version ??= "1";
  }
  return data;
}, z.discriminatedUnion("version", [opgavekompleksetV2DataSchema, opgavekompleksetV1DataSchema]));

export { opgavekompleksetDataSchema };
//# sourceMappingURL=_component-data.js.map
